import { forwardRef } from 'react';

import { SelectProps } from './Select.types';
import { SelectStyled, StyledPlaceholder } from './Select.styled';

const hasValue = (value: any) => value !== '' && value !== undefined && value !== null;

export const Select = forwardRef<unknown, SelectProps>(
  ({ MenuProps, placeholder, displayEmpty, renderValue, value, ...props }: SelectProps, ref) => {
    return (
      <SelectStyled
        MenuProps={
          MenuProps ?? {
            PaperProps: {
              style: {
                marginTop: '6px',
                boxShadow: '0 4px 8px 0 rgb(34 38 72 / 32%)',
              },
            },
          }
        }
        displayEmpty={Boolean(placeholder) ?? displayEmpty}
        renderValue={
          placeholder && !hasValue(value)
            ? (selected: any) => {
                if (selected?.length) {
                  return Array.isArray(selected) ? selected.join(', ') : selected;
                }
                return <StyledPlaceholder aria-label="placeholder text">{placeholder}</StyledPlaceholder>;
              }
            : renderValue
        }
        {...props}
        ref={ref}
        value={value}
      />
    );
  },
);

Select.displayName = 'Select';
